<template>
	<div class="content-box">
		<h3 class="text-center mb-3">{{info.type.name}}</h3>
		<info-table
			ref="baseInfoTable"
			data-model-name="Transaction"
			:record-id="recordId"
			:fields="infoFields"
			:auto-load="false"
		></info-table>
	</div>
</template>

<script>
import TxOp from "@/mixinsApp/TxOp.js";
import TxInfo from "@/mixinsApp/TxInfo.js";

export default {
	mixins: [TxInfo, TxOp],
	data() {
		return {
			infoFields: [
				[
					{
						name: "warehouse",
						col: 2,
					},
					{
						name: "show_id",
						col: 2,
					},
					{
						name: "tx_at",
						params: {
							type: "date",
						},
						col: 2,
					},
					{
						name: "verify_at",
						params: {
							type: "date",
						},
						col: 2,
					},
				],
				[
					{
						name: "desc",
						col: 6,
					},
				],
			],
		};
	},
};
</script>
